module.exports = __webpack_public_path__ + "img/12_bg.bf1c3a0c.jpg";